import { Deserializer } from "jsonapi-serializer";
import { DeviceAction, DeviceActionWrapper } from "../models/DeviceAction";
import { genericError } from "../models/GenericError";
import { ListQuery } from "../models/ListQuery";
import { Name } from "../models/Name";
import { PaginationModel } from "../models/Pagination";
import { APIConnector } from "./api/APIConnector";
import { createPagination } from "./utilities/paginationBuilder";
import { processServerError, getConstraintViolation } from "./utilities/ServiceError";
import { getDeviceSettingStatus } from "./utilities/StatusBuilder";
import { createPartialURL, getFilterClause } from "./utilities/urlBuilder";

const apiConnector = new APIConnector();

export const getDeviceActions = async (itemId: string, listParameters?: ListQuery): Promise<DeviceActionWrapper> => {
    try {
        const defaultSortBy = 'deviceImprox.devName,devActionNo,setting.settingType.id';
        const filter: string = getFilterClause(listParameters?.filters, listParameters?.searchTerm);
        const paginationString = createPartialURL(listParameters?.goToPage, listParameters?.pageSize, listParameters?.sortBy, filter, defaultSortBy);
        const fieldsDevAction = 'fields[devAction]=devActionNo,setting,deviceImprox';
        const fieldsController = 'fields[controller]=devName';
        const fieldsTerminal = 'fields[terminal]=devName';
        const fieldsSetting = 'fields[setting]=trnName,settingType,hierarchyType';
        const fieldsSettingType = 'fields[settingType]=trnName';
        const url = `deviceImprox/${itemId}/devActions?include=deviceImprox,setting.settingType&${paginationString}&${fieldsDevAction}&${fieldsSetting}&${fieldsController}&${fieldsTerminal}&${fieldsSettingType}`;

        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const pagination = createPagination(json.meta);

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }
            new Deserializer().deserialize(json, (error: any, data: any[]) => {
                if (error) {
                    return reject({status: response.status, message: genericError });
                }

                const deviceAction: DeviceAction[] = data.map((deviceAction): DeviceAction => {
                    return {
                        id: deviceAction['id'],
                        name: deviceAction['setting']['trn-name'],
                        type: deviceAction['setting']['setting-type']['trn-name'],
                        status: getDeviceSettingStatus(deviceAction['setting']['hierarchy-type'] ? deviceAction['setting']['hierarchy-type'] : 0),
                        device: deviceAction['device-improx']['dev-name'] ? deviceAction['device-improx']['dev-name'] : ''
                    }
                })

                return resolve({ rows: deviceAction, pagination });
            })
        });
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}


export const getDeviceActionNamesForDoorWithPagination = async (listParameters?: ListQuery): Promise<{ rows: Name[], pagination: PaginationModel }> => {
    try {
        const filter: string = getFilterClause(listParameters?.filters,listParameters?.searchTerm);
        const partialURL = createPartialURL(listParameters?.goToPage,listParameters?.pageSize,listParameters?.sortBy,filter);

        const settingFields = 'fields[setting]=trnName';
        const deviceImproxFields = 'fields[deviceImprox]=devName';
        const devActionFields = 'fields[devAction]=setting,deviceAction';
        const deviceActionFields = 'fields[deviceAction]=deviceImprox';
        let url = `devAction?include=setting,deviceAction.deviceImprox&${deviceActionFields}&${settingFields}&${deviceImproxFields}&${devActionFields}${partialURL}`;
        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const newPagination = createPagination(json.meta);

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }
            new Deserializer().deserialize(json, (err: any, data: any[]) => {
                if (err) {
                    return reject({status: response.status, message: genericError });
                }
                const deviceActionNames: Name[] = data.map((deviceAction): Name => {
                    return {
                        value: deviceAction['id'], label: deviceAction['setting']['trn-name'], optionalColumns: [{ key: 'device', value: deviceAction['device-action']?.['device-improx']?.['dev-name'] }]
                    };
                });

                return resolve({ rows: deviceActionNames, pagination: newPagination });
            });
        });
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}
